import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constant } from '../common/constant';
import { Observable } from 'rxjs';
import { UserRegisterModel } from '../models/registerUser.model';
import { ChangePasswordModel } from '../models/changePassword.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

    constructor(private readonly http: HttpClient) {
    }

    getAllUsers(params, search, accountId) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_ALL_USERMASTER
            + '?page='
            + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + search
            + '&accountId=' + accountId;
        return this.http.get(url);
    }

    getAllUsersWIthOutAccountId(params, search) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_ALL_USERMASTER
            + '?page='
            + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + search;
        return this.http.get(url);
    }

    registerUser(details): Observable<UserRegisterModel> {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.REGISTER_USERMASTER;
        return this.http.post<UserRegisterModel>(url, details);
    }

    findUserById(id, forEdit = false) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_USERMASTER_BY_ID + '?userMasterId=' + id + (forEdit ? '&forEdit=true' : '');
        return this.http.get(url);
    }

    getUserList(id, type) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_USER_LIST + '?accountId=' + id + '&type=' + type;
        return this.http.get(url);
    }

    auditTrailReport(params, startDate, endDate, accountId, username) {
        const url = Constant.REST_URL + Constant.AUDTI + Constant.GET_ALL_AUDIT_TRAIL
            + '?page='
            + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction='
            + '&accountId=' + accountId + '&startDate=' + startDate + '&endDate=' + endDate + '&username=' + username;
        return this.http.get(url);
    }

    getImageBase64(imageName) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.GET_BASE64_BY_IMAGE_NAME + '?imageName=' + imageName;
        return this.http.get(url);
    }

    exitedVisitorReport(params, startDate, endDate, accountId, type, mode, flatId , contractorType, driveMode,companyName) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.EXITED_VISITOR_REPORT
            + '?page='
            + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction='
            + '&accountId=' + accountId + '&startDate=' + startDate + '&endDate=' + endDate + '&type=' + type + '&mode=' + mode + '&flatId=' + flatId + '&contractorType=' + contractorType + '&driveMode=' + driveMode + '&companyName=' + companyName;
        return this.http.get(url);
    }

    exitedVisitorReportAsPDF(accountId, startDate, endDate, type, mode, minutes,contractorType, driveMode,companyName,flatId) {
        const url = Constant.REST_URL + Constant.REPORT + Constant.EXITED_REPORT_AS_PDF
            + '?accountId=' + accountId + '&startDate=' + startDate + '&endDate=' + endDate + '&type=' + type + '&mode=' + mode + '&minute=' + minutes + '&contractorType=' + contractorType + '&driveMode=' + driveMode+ '&companyName=' + companyName + '&flatId=' + flatId;
        return this.http.get(url, {
            responseType: 'arraybuffer'
        });
    }

    exitedVisitorReportAsExcel(accountId, startDate, endDate, type, mode, minutes, contractorType, driveMode, companyName, flatId, format = 'excel') {
        const url = Constant.REST_URL + Constant.REPORT + Constant.EXITED_REPORT_AS_EXCEL
            + '?accountId=' + accountId + '&startDate=' + startDate + '&endDate=' + endDate + '&type=' + type + '&mode=' + mode + '&minute=' + minutes + '&contractorType=' + contractorType + '&driveMode=' + driveMode + '&companyName=' + companyName + '&flatId=' + flatId + '&format=' + format;
        return this.http.get(url, {
            responseType: 'arraybuffer'
        });
    }

    exportAuditTrail(accountId, startDate, endDate, username, minutes, format = 'pdf') {
        const url = Constant.REST_URL + Constant.REPORT + Constant.EXPORT_AUDIT_TRAIL
            + '?accountId=' + accountId + '&startDate=' + startDate + '&endDate=' + endDate + '&username=' + username + '&minute=' + minutes + '&format=' + format;
        return this.http.get(url, {
            responseType: 'arraybuffer'
        });
    }

    changePassword(details) {
        const url = Constant.REST_URL + Constant.ACCOUNT + Constant.CHANGE_PASSWORD;
        return this.http.post<UserRegisterModel>(url, details);
    }

    resetPasswordChange(details) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.CHANGED_PASSWORD;
        return this.http.post<UserRegisterModel>(url, details);
    }

    getCountryList(search) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_DIALING_CODE_LIST + '?search=' + search;
        return this.http.get(url);
    }

    getCountyList(countryId) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_COUNTY_LIST + '?countryId=' + countryId;
        return this.http.get(url);
    }

    registerCountyList(details) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.REGISTER_COUNTY;
        return this.http.post<UserRegisterModel>(url, details);
    }

    getProfileList(search) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_PROFILE_LIST + '?search=' + search;
        return this.http.get(url);
    }

    getCompanyList(search) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_COMPANY_LIST + '?search=' + search;
        return this.http.get(url);
    }

    resetPassword(details) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.RESET_PASSWORD;
        return this.http.post<UserRegisterModel>(url, details);
    }

    getAllResetPasswordRequest(params, search, accountId) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_PASSWORD_RESET_REQUEST
            + '?page='
            + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + search
            + '&accountId=' + accountId;
        return this.http.get(url);
    }

    checkResetLinkExpire(details) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.CHECK_LINK_EXPIRE;
        return this.http.post<ChangePasswordModel>(url, details);
    }

    generatePasswordLink(details) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GENERATE_PASSWORD_LINK;
        return this.http.post<ChangePasswordModel>(url, details);
    }

    getDeviceUserDetails(username) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_USER_DETAILS + '?username=' + username;
        return this.http.get(url);
    }

    visitorVehicleReport(params, startDate, endDate, accountId, type) {
        const url = Constant.REST_URL + Constant.GUEST + Constant.VISITOR_VEHICLE_REPORT + '?page='
            + (params.currentPage - 1) + '&size=' + params.itemsPerPage + '&accountId=' + accountId + '&startDate=' + startDate + '&endDate=' + endDate + '&type=' + type;
        return this.http.get(url);
    }

    visitorVehiclePDFReport(accountId, startDate, endDate, type, mode, minutes) {
        const url = Constant.REST_URL + Constant.REPORT + Constant.EXPORT_VEHICLE_REPORT
            + '?accountId=' + accountId + '&startDate=' + startDate + '&endDate=' + endDate + '&type=' + type + '&mode=' + mode + '&timezone=' + minutes;
        return this.http.get(url, {
            responseType: 'arraybuffer'
        });
    }

    visitorVehicleExcelReport(accountId, startDate, endDate, type, mode, minutes, format = 'excel') {
        const url = Constant.REST_URL + Constant.REPORT + Constant.EXPORT_VEHICLE_REPORT
            + '?accountId=' + accountId + '&startDate=' + startDate + '&endDate=' + endDate + '&type=' + type + '&mode=' + mode + '&timezone=' + minutes + '&format=' + format;
        return this.http.get(url, {
            responseType: 'arraybuffer'
        });
    }

    changeTresspasserNotification(details) {
        const url = Constant.REST_URL + Constant.NOTIFICATION + Constant.ENABLE_DEVICE_NOTIFICATION;
        return this.http.post<ChangePasswordModel>(url, details);
    }

    getVisitorGraphicalReport(accountId, flatId, startDate, endDate) {
        const url = Constant.REST_URL + Constant.REPORT + Constant.GET_VISITOR_GRAPHICAL_REPORT + '?accountId=' + accountId + '&flatId=' + flatId + '&startDate=' + startDate + '&endDate=' + endDate;
        return this.http.get(url);
    }

    getVisitorBarChartReport(accountId, flatId, startDate, endDate, mode) {
        const url = Constant.REST_URL + Constant.REPORT + Constant.GET_VISITOR_BAR_CHRT + '?accountId=' + accountId + '&flatId=' + flatId + '&startDate=' + startDate + '&endDate=' + endDate + '&mode=' + mode;
        return this.http.get(url);
    }

    getDeviceUserList(accountId) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_DEVICE_USER_LIST + '?accountId=' + accountId;
        return this.http.get(url);
    }

    createEntryPoint(details) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.CREATE_ENTRY_POINT;
        return this.http.post(url, details);
    }

    getAllEntryPoint(accountId) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_ALL_ENTRY_POINT + '?accountId=' + accountId;
        return this.http.get(url);
    }

    deleteEntryPoint(accountId, entryPointId) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.DELETE_ENTRY_POINT + '?accountId=' + accountId + '&entryPointId=' + entryPointId;
        return this.http.get(url);
    }
    getGateMasterList(accountId) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_ALL_GATE + '?accountId=' + accountId;
        return this.http.get(url);
    }

    createGateMasterMapping(details) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.CREATE_GATE_MASTER;
        return this.http.post(url, details);
    }
    deleteGateMaster(accountId, gateMasterId) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.DELETE_GATE_MASTER + '?accountId=' + accountId + '&gateMasterId=' + gateMasterId;
        return this.http.get(url);
    }
    updateGateStatus(accountId, gateMasterId, status) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.UPDATE_GATE_STATUS
            + '?accountId=' + accountId + '&gateMasterId=' + gateMasterId + '&status=' + status;
        return this.http.get(url);
    }
    getCompanyListByContractorType(contractorType) {
        const url = Constant.REST_URL + Constant.USERMASTER + Constant.GET_COMPANY_LIST_BY_CONTRACTOR_TYPE + '?contractorType=' + contractorType;
        return this.http.get(url);
         
    }
    
    getVechileGraphicalReport(accountId,startDate, endDate) {
        const url = Constant.REST_URL + Constant.REPORT + Constant.GET_VEHICLE_GRAPHICAL_REPORT + '?accountId=' + accountId + '&startDate=' + startDate + '&endDate=' + endDate;
        return this.http.get(url);
    }

    getCurrentVisitorServiceProviderBarChartReport(accountId,startDate, endDate) {
        const url = Constant.REST_URL + Constant.REPORT + Constant.GET_CURRENT_VISITOR__SERVICE_PROVIDER_BAR_CHART + '?accountId=' + accountId + '&startDate=' + startDate + '&endDate=' + endDate;
        return this.http.get(url);
    }

    getOcrReport(accountId) {
        const url = Constant.REST_URL + Constant.REPORT + Constant.GET_OCR_REPORT + '?accountId=' + accountId;
        return this.http.get(url);
    }

}